import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {
  Alert,
  Box,
  Button,
  Card,
  Container,
  Grid,
  Link,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';

import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const BestForm941Software = () => {
  const containerRef = useRef(null);

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [removelistener, setRemovelistener] = useState(true);
  const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  const images = [
    '/assets/images/2290-steps-img.webp',
    '/assets/images/easy-steps-img.webp',
    '/assets/images/941-steps-img.webp',
    // Add more image URLs as needed
  ];
  const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  const handleScroll = (event: any) => {
    const delta = event.deltaY;
    if (delta > 0) {
      // Scroll down, show the next imag
      if (currentImageIndex < 2) {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else if (delta < 0) {
      // Scroll up, show the previous image
      if (currentImageIndex > 0) {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        setRemovelistener(false);
      } else {
        setRemovelistener(true);
      }
    } else {
      setRemovelistener(false);
    }
  };
  function useHorizontalScroll() {
    useEffect(() => {
      const el = Ref.current;
      setTempReturn(tempReturn);
      if (el) {
        const onWheel = (e: any) => {
          if (e.deltaY === 0) return;
          e.preventDefault();
          el.scrollTo({
            behavior: 'smooth',
            top: 0,
            left: 0,
          });
        };

        el.addEventListener('wheel', onWheel);
        if (removelistener === false) {
          el.addEventListener('wheel', onWheel);
        } else if (removelistener === true) {
          el.removeEventListener('wheel', onWheel);
        } else {
          el.addEventListener('wheel', onWheel);
        }
        return () => {
          el.removeEventListener('wheel', onWheel);
        };
      }
      return () => setTempReturn(false);
    }, [removelistener]);
    return Ref;
  }

  const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Best Form 941 E-File Software (2026)"
          description="Compare the best Form 941 e-file software for 2026. Explore features, pricing, and benefits to find the right IRS-authorized filing solution for your business."
          keywords=""
          canonical="comparison/best-form-941-software/"

          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(
    180deg,
    #e9eeff 0%,
    #edfaf1 50%,
    #ffffff 100%
  )
`,
          overflow: 'hidden',
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              Find the Best Form 941 <br />
              E-File Software for Your Business
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                  lg: 22,
                  xl: 24,
                },
                fontWeight: 400,
                mb: 4,
                color: '#5b6472',
                lineHeight: 1.7,
                maxWidth: 950,
                mx: 'auto',
              }}
            >
              Compare Form 941 e-file software based on pricing, filing
              features, ease of use & support. Explore how TaxZerone and other
              providers differ to find an option that fits your business,
              accounting, or payroll needs.
            </Typography>

            <Stack
              alignItems="center"
              sx={{
                width: '100%',
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                className="btn-primary"
                sx={{
                  backgroundColor: '#1e2f8f',
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: 16,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  boxShadow: 'none',
                  transition: 'all 0.3s ease',
                  '&:hover, &:focus, &:active': {
                    backgroundColor: '#16247a',
                    transform: 'scale(1.05)',
                  },
                }}
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-tax1099`}
              >
                Get Started for Free
              </Button>

              <Typography
                variant="body2"
                sx={{
                  mt: 2,
                  fontSize: 14,
                  color: '#9aa1ab',
                  fontWeight: 500,
                }}
              >
                No credit card required. Pay only when you file.
              </Typography>
            </Stack>
            {/* 
            <Typography
              sx={{
                mt: 0.5,
                fontSize: 11.5,
                color: '#98a2b3',
                textAlign: 'center',
              }}
            >
              Based on customer reviews
            </Typography> */}
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Compare TaxZerone{' '}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 'clamp(18px, 3vw, 38px)',
                  }}
                >
                  vs
                </span>{' '}
                Alternatives
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                See head-to-head comparisons against the most common platforms.
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="xl"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ px: { xs: 2, md: 3 } }}>
            <Box
              ref={containerRef}
              sx={{
                overflow: 'hidden',
                py: 2,
              }}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={3}
                sx={{
                  alignItems: 'stretch',
                  justifyContent: 'center',
                  p: 2,
                  maxWidth: '1200px',
                  mx: 'auto',
                }}
              >
                {/* Card 1 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-tax1099.png"
                        alt="TaxZerone vs Tax1099"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs Tax1099
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Tired of complex pricing tiers?
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          See why businesses are switching to TaxZerone for
                          transparent pricing, a faster filing process.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#tax1099"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 2 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-efile4biz-img.png"
                        alt="TaxZerone vs EFile4Biz"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs EFile4Biz
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Choosing the right tax e-file provider matters.
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Compare both platforms and see how TaxZerone
                          simplifies filing with affordable pricing.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#efile4biz"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>

                {/* Card 3 */}
                <Box
                  sx={{
                    flex: { xs: '1 1 100%', md: '1 1 0' },
                    width: '100%',
                    display: 'flex',
                  }}
                >
                  <Card
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      background: '#ffffff',
                      position: 'relative',
                      border: '1px solid #EDEDED',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.05)',
                      '&:hover': {
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.1)',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pt: 4,
                        pb: 2,
                        px: 2,
                        height: 140,
                      }}
                    >
                      <Box
                        component="img"
                        src="/assets/images/taxzerone-vs-sovos-img.png"
                        alt="TaxZerone vs Sovos"
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </Box>

                    <Box
                      sx={{
                        p: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: 18,
                            fontWeight: 700,
                            color: '#111827',
                            mb: 1.5,
                          }}
                        >
                          TaxZerone vs Sovos
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: '#111827',
                            mb: 0.5,
                          }}
                        >
                          Looking for a simpler e-filing experience?
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 13.5,
                            lineHeight: 1.6,
                            color: '#6B7280',
                            mb: 3,
                          }}
                        >
                          Compare pricing, features, and filing solutions to see
                          why businesses choose TaxZerone.
                        </Typography>
                      </Box>

                      <Button
                        variant="contained"
                        href="#sovos"
                        fullWidth
                        sx={{
                          backgroundColor: '#333333',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: 14,
                          py: 1.2,
                          borderRadius: 6,
                          textTransform: 'none',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: '#000000',
                          },
                        }}
                      >
                        Compare
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#eef9fa',
          my: { xs: 0, md: 8 },
          py: { xs: 4, md: 4 },
        }}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 5 } }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={4}
            sx={{ my: { xs: 0, md: -23 } }}
          >
            {/* LEFT: TEXT */}
            <Box
              sx={{
                flex: 1,
                maxWidth: { md: 560 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,

                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  lineHeight: 1.3,
                  mb: 2,
                }}
              >
                Why Compare Form 941 E-File Software?
              </Typography>

              <Typography
                sx={{
                  lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                  mb: 2,
                }}
              >
                Not all Form 941 software offers the same filing experience.
                While every IRS-authorized provider helps transmit your return
                electronically, differences in pricing, workflow, validation
                tools, customer support, and business management features can
                have a significant impact on your filing experience.
              </Typography>

              <Typography
                sx={{
                  lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                }}
              >
                Before choosing a provider, consider factors such as filing
                accuracy, ease of use, support for multiple EINs, bulk filing
                capabilities, and real-time IRS status updates.
              </Typography>
            </Box>

            {/* RIGHT: IMAGE WITH FLOATING LABELS */}
            <Box
              sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: 280, sm: 340, md: 380 },
                mx: 'auto',
                my: { xs: 0, md: 4 },

                px: { xs: 2, sm: 0 },
              }}
            >
              <Box
                component="img"
                src="/assets/images/why-compare-form-941-e-file-software-img.webp"
                alt="TaxZerone mascot in a suit holding a briefcase"
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  position: 'relative',
                  zIndex: 1,
                }}
              />

              {/* 1. Transparent Pricing */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '5%', sm: '12%', md: '20%' },
                  left: { xs: '-5%', sm: '-12%', md: '-15%' },
                  bgcolor: '#FBE4E0',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Transparent
                <br /> Pricing
              </Box>

              {/* 2. Instant Email Notifications */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '38%', sm: '40%', md: '42%' },
                  right: { xs: '-8%', sm: '-20%', md: '-25%' },
                  bgcolor: '#F7D9CE',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Instant
                <br /> Email Notifications
              </Box>

              {/* 3. Online Filing in Minutes */}
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '50%' },
                  left: { xs: '-6%', sm: '-8%', md: '-4%' },
                  bgcolor: '#E3DEF7',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Online Filing
                <br />
                in Minutes
              </Box>

              {/* 4. Simplify Client Approvals */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '5%', sm: '10%', md: '12%' },
                  left: { xs: '0%', sm: '5%', md: '8%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#F6D9E8',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Simplify
                <br />
                Client Approvals
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                TaxZerone{' '}
                <span
                  style={{
                    fontWeight: 500,
                    fontSize: 'clamp(18px, 3vw, 38px)',
                  }}
                >
                  vs
                </span>{' '}
                Traditional Providers
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                See how we compare with standard legacy filing platforms.
              </Typography>

              <TableContainer
                sx={{
                  border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 5,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 700,
                      borderCollapse: 'collapse',
                      width: '100%',

                      '& thead': {
                        background: '#0f172a',
                      },

                      '& thead th': {
                        fontSize: {
                          xs: '11px',
                          sm: '12px',
                          md: '13px',
                        },
                        fontWeight: 600,
                        textAlign: 'left',
                        padding: {
                          xs: '10px 8px',
                          sm: '14px 16px',
                          md: '16px 20px',
                        },
                        letterSpacing: '0.08em',

                        whiteSpace: 'nowrap',
                      },

                      '& tbody tr': {
                        transition: 'background-color 0.15s ease',
                      },

                      '& tbody tr:nth-of-type(even)': {
                        backgroundColor: '#f8fafc',
                      },

                      '& tbody td': {
                        fontSize: {
                          xs: '12px',
                          sm: '13.5px',
                          md: '14.5px',
                        },
                        fontWeight: 400,
                        textAlign: 'left',
                        padding: {
                          xs: '10px 8px',
                          sm: '13px 16px',
                          md: '13px 20px',
                        },
                        color: '#1e293b',
                        // borderBottom: '1px solid #e4eaf0',
                        borderBottom: 'none',
                        transition: 'color 0.15s ease',
                      },

                      '& tbody td:first-of-type': {
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        color: '#0f172a',
                      },

                      '& tbody tr:last-of-type td': {
                        borderBottom: 'none',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            background: '#fff',
                            borderBottom: 'none',
                            position: 'relative',
                            paddingBottom: '20px',

                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              bottom: 0,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              width: '85%',
                              height: '1.5px',
                              backgroundColor: '#e2e8f0',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                              fontWeight: 700,
                            }}
                          >
                            Feature / Benefit
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            background: '#213e99',
                            textAlign: 'center',
                            color: '#ffffff',
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            borderBottom: '2px solid #213e99',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                              width: '100%',
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              TaxZerone
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            background: '#fff',
                            borderBottom: 'none',
                            position: 'relative',
                            paddingBottom: '20px',

                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              bottom: 0,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              width: '85%',
                              height: '1.5px',
                              backgroundColor: '#e2e8f0',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '100%',
                            }}
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: { xs: 12, sm: 14, md: 16 },
                                fontWeight: 700,
                                whiteSpace: 'nowrap',
                                color: '#0f172a', // Matches dark text color from image
                              }}
                            >
                              Legacy Competitors
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow>
                        <TableCell>Pricing Structure</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Transparent, pay per return
                        </TableCell>
                        <TableCell>
                          Tiered pricing or subscription plans
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Hidden Fees</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          None
                        </TableCell>
                        <TableCell>
                          Additional charges may apply for features, or services
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Filing Speed</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Fast online filing in minutes
                        </TableCell>
                        <TableCell>
                          Longer setup and manual data entry
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Error Validation</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Built-in IRS business rule checks before filing
                        </TableCell>
                        <TableCell>Limited or basic validation</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>E-Sign</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Simplify client approvals with secure digital
                          signatures (ZeroneVault)
                        </TableCell>
                        <TableCell>
                          Slower approval workflows with additional steps
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Customer Support</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Free U.S.-based support via phone, email, and chat
                        </TableCell>
                        <TableCell>
                          Limited hours, paid plans, or slower response times
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Status Updates</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Instant email notifications on IRS acceptance
                        </TableCell>
                        <TableCell>Delayed or limited notifications</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>User Experience</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Simple, intuitive interface designed for quick filing
                        </TableCell>
                        <TableCell>
                          Complex workflows with multiple steps
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>File Tracking</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            fontWeight: 600,
                          }}
                        >
                          Real-time filing progress and submission updates
                        </TableCell>
                        <TableCell>Limited tracking after submission</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>Scalability</TableCell>
                        <TableCell
                          sx={{
                            borderLeft: '2px solid #213e99',
                            borderRight: '2px solid #213e99',
                            borderBottom: '2px solid #213e99 !important',
                            fontWeight: 600,
                          }}
                        >
                          Built for businesses, CPAs, payroll providers, and
                          growing teams
                        </TableCell>
                        <TableCell>
                          May be better suited for basic filing needs
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Alert
                icon={
                  <InfoOutlinedIcon sx={{ color: '#475569', fontSize: 22 }} />
                }
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 2,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                Feature comparisons are based on publicly available information
                and are provided for informational purposes only. Features,
                pricing, and availability may change without notice. Please
                verify the latest details with the respective providers before
                making a decision.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 24,
                    sm: 28,
                    md: 34,
                    lg: 42,
                    xl: 48,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to choose the right platform
              </Typography>
            </Grid>
          </Grid>
        </Container>

        <Container
          maxWidth="lg"
          sx={{ mb: 5 }}
          ref={scrollRef}
          className="image-gallery"
          onWheel={handleScroll}
        >
          <Box sx={{ py: { xs: 2, md: 2 } }}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="stretch"
              sx={{ p: 0 }}
            >
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#f8e7fb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <TouchAppIcon
                      sx={{
                        color: '#c55ad9',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Ease of use
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    A guided workflow and clean UI cut down on data-entry errors
                    before they ever reach the IRS.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dff8e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <UploadFileIcon
                      sx={{
                        color: '#2e7d32',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Filing volume
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Single business? Simple tools work fine. Multiple clients?
                    You need to bulk upload and multi-EIN.
                  </Typography>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  sx={{
                    height: '100%',
                    textAlign: { xs: 'center', md: 'left' },
                    maxWidth: { xs: '100%', md: 340 },
                    mx: { xs: 'auto', md: 0 },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      background: '#dfe8ff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      mx: { xs: 'auto', md: 0 },
                    }}
                  >
                    <FactCheckIcon
                      sx={{
                        color: '#3056d3',
                        fontSize: 30,
                      }}
                    />
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                    }}
                  >
                    Error prevention
                  </Typography>

                  <Typography
                    sx={{
                      color: '#4b5563',
                      lineHeight: 1.8,
                    }}
                  >
                    Look for built-in validation tools that identify potential
                    errors before submission, helping reduce IRS rejections,
                    corrections, and unnecessary filing delays.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box sx={{ py: 3, px: 2, maxWidth: '1200px', mx: 'auto' }}>
              <Box textAlign="center" sx={{ mb: 2 }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: {
                      xs: 24,
                      sm: 28,
                      md: 34,
                      lg: 42,
                      xl: 48,
                    },
                    fontWeight: 600,

                    mb: 1,
                  }}
                >
                  Trusted by Businesses Who Made <br />
                  the Switch
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: {
                      xs: 16,
                      sm: 18,
                      md: 18,
                      lg: 20,
                      xl: 22,
                    },

                    mb: 2,
                  }}
                >
                  See what CPAs and payroll professionals are saying
                </Typography>
              </Box>

              <Grid container spacing={0}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    textAlign: 'center',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                {/* COLUMN 1 */}
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        We tried a few other filing platforms before switching
                        to TaxZerone. The pricing is clear, the process is
                        straightforward, and we don’t have to worry about
                        unexpected fees.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        William Jefferson
                      </Typography>
                    </Paper>

                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        I like that everything is straightforward. I don’t have
                        to search through multiple screens to complete a Form
                        941 return. The validation checks are helpful because
                        they catch issues before I submit.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Gary Edmonds
                      </Typography>
                    </Paper>
                  </Stack>
                </Grid>

                {/* COLUMN 2 */}
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#EBE0FF', // Soft purple fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        TaxZerone helps us spend less time on the filing process
                        and more time supporting our clients. It has become a
                        valuable part of our workflow.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Billy Marrale
                      </Typography>
                    </Paper>

                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        I like you guys! The whole process was way simpler than
                        I expected. Even the signature part was easy, and I was
                        able to get everything submitted without needing any
                        support.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        James C Bates
                      </Typography>
                    </Paper>
                  </Stack>
                </Grid>

                {/* COLUMN 3 */}
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        What I appreciate most is how clearly the filing process
                        is organized. I can work through each section, review
                        what I entered, and know exactly what I need to do next.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Andrew Barofsky
                      </Typography>
                    </Paper>

                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Compared with the other platforms I’ve tried, TaxZerone
                        just feels easier. I don’t have to spend a bunch of time
                        figuring out the steps before I can actually file.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Martin Spence
                      </Typography>
                    </Paper>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1100px', mx: 'auto' }}
          >
            {/* HEADING */}
            <Typography
              variant="h2"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 28,
                  md: 34,
                  lg: 42,
                  xl: 48,
                },
                fontWeight: 600,
                textAlign: 'center',
                mb: 5,
              }}
            >
              Best Form 941 E-File Providers Compared
            </Typography>

            <Stack spacing={4}>
              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  overflow: 'hidden',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                }}
              >
                {/* Header Bar */}
                <Box
                  sx={{
                    backgroundColor: '#213e99',
                    color: '#ffffff',
                    p: { xs: 2.5, md: 3 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 800,
                        fontSize: { xs: '20px', md: '24px' },
                      }}
                    >
                      TaxZerone
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ opacity: 0.9, fontSize: '13px', mt: 0.5 }}
                    >
                      Best Form 941 Software for Businesses, CPAs & Payroll
                      Providers
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: '#30E3B2',
                      color: '#044E3A',
                      px: 2.5,
                      py: 0.8,
                      borderRadius: '50px',
                      fontWeight: 700,
                      fontSize: '13px',
                    }}
                  >
                    Recommended
                  </Box>
                </Box>

                {/* Card Body */}
                <Box sx={{ p: { xs: 2.5, sm: 4 } }}>
                  <Typography
                    sx={{
                      color: '#64748B',
                      lineHeight: 1.6,
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    TaxZerone is a leading IRS-authorized e-file provider for
                    Form 941, helping businesses, accountants, and payroll
                    providers complete quarterly payroll tax filings with speed,
                    accuracy, and confidence. With a guided filing workflow,
                    built-in validation checks, and user-friendly tools,
                    TaxZerone simplifies the Form 941 e-filing process from
                    start to finish.
                  </Typography>

                  {/* Pros / Cons Table Box */}
                  <Grid
                    container
                    sx={{
                      border: '1px solid #E2E8F0',
                      borderRadius: '12px',
                      backgroundColor: '#F8FAFC',
                      mb: 3,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Pros */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{
                        p: { xs: 2.5, sm: 3 },
                        borderRight: { md: '1px solid #E2E8F0' },
                        borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Pros
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Easiest workflow — minimal learning curve
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Industry-best error validation (99% acceptance rate)
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Full support for 94X forms and Schedule B
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Multi-EIN dashboard for managing many clients
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Bulk upload saves hours every quarter
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Real-time IRS acceptance/rejection alerts
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Transparent, affordable pay-per-file pricing
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <CheckIcon
                            sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            U.S.-based customer support team
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Cons */}
                    <Grid
                      size={{ xs: 12, md: 6 }}
                      sx={{ p: { xs: 2.5, sm: 3 } }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 700,
                          fontSize: '15px',
                          mb: 2,
                          color: '#0F172A',
                        }}
                      >
                        Cons
                      </Typography>
                      <Stack spacing={1.2}>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Web-based only (no mobile app yet)
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            alignItems: 'flex-start',
                          }}
                        >
                          <ClearIcon
                            sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ color: '#334155', fontSize: '13px' }}
                          >
                            Focused on IRS payroll forms — not a full accounting
                            suite
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  </Grid>

                  {/* Best for & CTA Button */}
                  <Typography
                    sx={{
                      color: '#0F172A',
                      fontSize: '14px',
                      mb: 3,
                    }}
                  >
                    <strong>Best for:</strong> Businesses, CPAs, Payroll
                    Providers — any size
                  </Typography>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      className="btn-primary"
                      id="tax1099"
                      sx={{
                        mt: 2,
                        px: '20px !important',
                        py: '8px !important',
                        fontSize: '18px !important',

                        transition: 'all 0.3s ease',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.05)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-941-software`}
                    >
                      Get Started for Free
                    </Button>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                  }}
                >
                  Tax1099
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  Tax1099 supports Form 941 filing with API capabilities that
                  help businesses integrate payroll tax filing into their
                  existing workflows. While the platform provides tools for
                  managing Form 941 submissions, new users may need some time to
                  become familiar with its interface and navigation.
                </Typography>

                {/* Pros / Cons Table Box */}
                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  {/* Pros */}
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Supports numerous IRS tax forms
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Offers bulk filing capabilities for high-volume
                          submissions
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Integrates with accounting platforms like QuickBooks,
                          Xero, and Zoho
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Includes multi-client tools for accountants
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Provides TIN matching, validation, and correction
                          support
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Supports recipient delivery options and API
                          integration
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          id="efile4biz"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Includes security features like two-factor
                          authentication and audit tracking
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  {/* Cons */}
                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Complex interface vs. TaxZerone
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Higher cost at volume
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Slower support response times
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                  }}
                >
                  Efile4Biz
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  Efile4Biz is an IRS-authorized e-file provider that supports
                  electronic filing for Form 941. It offers a web-based filing
                  experience for businesses and tax professionals looking to
                  submit quarterly payroll tax returns electronically.
                </Typography>

                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Supports electronic filing of Form 941
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Simple online filing workflow
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Built-in validation checks before submission
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Supports online access to filed records
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Useful for businesses needing basic quarterly payroll
                          tax filing
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Limited advanced Form 941 automation features
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Fewer features for payroll providers managing multiple
                          EINs and clients
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Lacks some specialized payroll tax tools for complex
                          filing scenarios
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          id="sovos"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Limited payroll-specific integrations and workflow
                          features
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  backgroundColor: '#ffffff',
                  borderRadius: '16px',
                  border: '1px solid #E2E8F0',
                  p: { xs: 2.5, sm: 4 },
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '20px', md: '22px' },
                    color: '#0F172A',
                    mb: 2,
                  }}
                >
                  Sovos
                </Typography>

                <Typography
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.6,
                    fontSize: '14px',
                    mb: 3,
                  }}
                >
                  Sovos provides enterprise tax compliance software for large
                  organizations with complex reporting requirements. Its
                  platform focuses on large-scale compliance, integrations, and
                  information reporting rather than serving as a dedicated Form
                  941 filing solution for small and mid-sized businesses.
                </Typography>

                <Grid
                  container
                  sx={{
                    border: '1px solid #E2E8F0',
                    borderRadius: '12px',
                    backgroundColor: '#F8FAFC',
                    overflow: 'hidden',
                  }}
                >
                  <Grid
                    size={{ xs: 12, md: 6 }}
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      borderRight: { md: '1px solid #E2E8F0' },
                      borderBottom: { xs: '1px solid #E2E8F0', md: 'none' },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Pros
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Enterprise-grade compliance platform
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Strong ERP integrations
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          High-volume filing capabilities
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Advanced compliance controls
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <CheckIcon
                          sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Suitable for multinational organizations
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }} sx={{ p: { xs: 2.5, sm: 3 } }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: '15px',
                        mb: 2,
                        color: '#0F172A',
                      }}
                    >
                      Cons
                    </Typography>
                    <Stack spacing={1.2}>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          More complex implementation than SMB-focused platforms
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Enterprise pricing may not suit small businesses
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          Not designed primarily as a Form 941 e-filing solution
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 1,
                          alignItems: 'flex-start',
                        }}
                      >
                        <ClearIcon
                          sx={{ fontSize: 18, color: '#DC2626', mt: '2px' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: '#334155', fontSize: '13px' }}
                        >
                          May provide more functionality than smaller employers
                          need
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: {
              xs: 24,
              sm: 28,
              md: 34,
              lg: 42,
              xl: 48,
            },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          File your Form 941 the way the top-ranked
          <br /> platform does it.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Guided workflow, built-in validation, and a multi-EIN dashboard —
          ready before the quarter closes.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=best-form-941-software`}
          >
            Get Started for Free
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>✓ No subscription</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>✓ Pay per file</Typography>
            <Typography sx={{ color: '#f3f3f3' }}>✓ U.S. support</Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="best-941-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                FAQ
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                {/* Question 1 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What is the best software to file Form 941?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        It depends on your filing volume and who you&apos;re
                        filing for — but for most CPAs, payroll providers, and
                        businesses filing quarterly at scale, TaxZerone offers
                        the strongest mix of ease of use, validation accuracy,
                        and multi-client support.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 2 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which software is better for high-volume Form 941 filing?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        For high-volume Form 941 filing, the better choice
                        depends on business needs. TaxZerone is designed for
                        businesses, CPAs, and payroll providers handling large
                        filing volumes with features like bulk upload, multi-EIN
                        management, IRS validation checks, real-time status
                        tracking, and pay-per-file pricing.
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Question 3 */}
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What should I look for when choosing Form 941 filing
                    software?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                        When choosing{' '}
                        <Link
                          href="/employment-tax/e-file-irs-form-941/"
                          sx={{ color: '#0202ff' }}
                        >
                          Form 941 filing software
                        </Link>{' '}
                        , look for IRS authorization, accurate error validation,
                        support for Form 941 and 941-X, bulk filing
                        capabilities, multi-EIN management, secure data
                        handling, real-time IRS status updates, easy payroll
                        data import, affordable pricing, and responsive customer
                        support. The right software should simplify quarterly
                        filing, reduce errors, and save time for businesses,
                        CPAs, and payroll providers.
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default BestForm941Software;
